import { NgModule, Injectable, Component, Input, Output, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  init(config: any) {}
  isAuthenticated(): boolean { return !!localStorage.getItem('ums_token'); }
  logout() { localStorage.clear(); }
}

@Injectable({ providedIn: 'root' })
export class UserService {
  getUserFromJwt(): any { return {}; }
  getBackgroundColor(name: string): string { return '#ccc'; }
}

@Injectable({ providedIn: 'root' })
export class DlvHttpService {
  httpRequest(option: any): any { return null; }
  handleError(err: any): any { return err; }
  responseData(res: any): any { return res; }
}

@Component({
  selector: 'delhivery-login',
  template: '<div>Login placeholder</div>'
})
export class DlvLoginComponent {
  @Output() afterLogin = new EventEmitter();
}

@Component({
  selector: 'delhivery-user-details',
  template: '<div>User Details</div>'
})
export class DlvUserDetailsComponent {
  @Input() isMaterialView: boolean = false;
  @Output() onLogout = new EventEmitter();
}

@NgModule({
  declarations: [DlvLoginComponent, DlvUserDetailsComponent],
  exports: [DlvLoginComponent, DlvUserDetailsComponent]
})
export class DlvNgAuthModule {}
